export default __webpack_public_path__ + "static/media/fairgo-logo.1c15c8a5.svg";